module.exports = __webpack_public_path__ + "static/media/2-wap.f32c6615.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageUrlSec/2-wap.png
// module id = 573
// module chunks = 0